// hooks/useFormValidation.js
import { useCallback } from 'react';
import { emailRegex, phoneRegex, quantityRegex, GSTRegex} from '../constants';

const useFormValidation = (formData) => {
  const validateForm = useCallback((enquiryType) => {
    if (!phoneRegex.test(formData["Phone number"].trim())) {
      alert("Invalid phone number format (10 digits)");
      return false;
    }

    if (!emailRegex.test(formData["Email Address"].trim())) {
      alert("Invalid email address format");
      return false;
    }

    if(enquiryType!=='ZOHOGENERAL'){
        if (!quantityRegex.test(formData["Quantity"].trim())) {
        alert("Quantity must be a positive integer");
        return false;
        }
    }

    if(enquiryType==='SELL'){
        if(!GSTRegex.test(formData["Company GST"].trim())){
            alert("Please enter valid GST");
            return false;
        }
    }

    return true;
  }, [formData]);

  return validateForm;
};

export default useFormValidation;
